import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { ForYou } from './components/ForYou';
import { Transition } from './components/Transition';
import { Features } from './components/Features';
import { Price } from './components/Price';
import { Bonuses } from './components/Bonuses';
import { SocialProof } from './components/SocialProof';
import { LogicStack } from './components/LogicStack';
import { Guarantee } from './components/Guarantee';
import { FooterCTA } from './components/FooterCTA';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="w-full min-h-screen bg-[#F8FAFC]" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <Hero data-id="element-2" />
      <hr className="border-none h-px bg-[#E2E8F0] m-0" data-id="element-3" />
      <ForYou data-id="element-4" />
      <Transition data-id="element-5" />
      <Features data-id="element-6" />
      <Price data-id="element-7" />
      <Bonuses data-id="element-8" />
      <SocialProof data-id="element-9" />
      <LogicStack data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FooterCTA data-id="element-12" />
      <RecentPurchaseToast data-id="element-13" />
    </div>;
}